import { defineComponent, computed } from 'vue'
import { buttonsProps } from './buttons'
import { createNameSpace } from '@el-plus/utils/bem'
import {
  prepareProps,
  prepareEvents,
  prepareClassNames,
  prepareStyles,
} from '@el-plus/utils/props'
import { vRepeatClick, vPermission } from '@el-plus/directives'
import { ElMessageBox } from 'element-plus'
import { useLocale } from '@el-plus/hooks/use-locale'
const bem = createNameSpace('button')

export default defineComponent({
  name: 'EpButtons',
  directives: {
    [vRepeatClick.name]: vRepeatClick,
    [vPermission.name]: vPermission,
  },
  inheritAttrs: false,
  props: buttonsProps,
  setup(props, { emit }) {
    const { t } = useLocale()
    const { list, ...buttonProps } = props
    const customList = computed(() => {
      return list.filter((button) => {
        if ('show' in button) {
          return typeof button.show === 'function'
            ? button.show(button)
            : button.show
        } else if ('hide' in button) {
          return typeof button.hide === 'function'
            ? !button.hide(button)
            : !button.hide
        }
        return true
      })
    })
    const clickFn = async (item) => {
      if (item.confirmBefore) {
        await item.confirmBefore()
      }
      if (item.confirm) {
        const confirmText =
          item.confirmText ||
          `${t('ep.buttons.secondConfirm')}${item.name}${t('ep.buttons.secondConfirmEnd')}？`
        await ElMessageBox.confirm(confirmText, t('ep.buttons.prompt'), {
          confirmButtonText: t('ep.buttons.confirm'),
          cancelButtonText: t('ep.buttons.cancel'),
          type: 'warning',
        })
      }
      item.onClick && item.onClick()
    }
    const getDisabled = (item) => {
      if (typeof item.disabled === 'function') {
        return item.disabled()
      }
      if (typeof props.disabled === 'function') {
        return props.disabled()
      }
      return props.disabled
    }

    return () => (
      <>
        {customList.value.map((item) => {
          const permissionArr = item.permission?.split(':') || []
          return (
            <el-button
              class={[bem.b(), prepareClassNames()]}
              style={prepareStyles()}
              key={item.prop || item.name}
              v-slots={{
                default: () => item.name,
                ...item.scopedSlots,
              }}
              {...{
                ...prepareProps(buttonProps),
                ...prepareProps(item, ['scopedSlots', 'name', 'onClick']),
                disabled: getDisabled(item),
              }}
              v-repeat-click={
                typeof item.onClick === 'function'
                  ? {
                      handler: () => clickFn(item),
                      immediate: true,
                    }
                  : () => clickFn(item)
              }
              v-permission={{
                arg: permissionArr[0],
                value: permissionArr[1],
              }}
            ></el-button>
          )
        })}
      </>
    )
  },
})
